export class AuthenticatedUser {
    id: number;
    firstName: string;
    lastName: string;
    supplierId: number;
    role: string;
    photoimg: string;
    isPresentImage: boolean;
}

export class AuthenticateUser {
    userId: number;
    roleId: string;
}


export class AuthenticationModel {
    username: string;
    password: string;
}

export class AuthenticationResetModel {
    resetPasswordToken: string;
    newPassword: string;
}

export class SupplierUserBasicModel {
    id: number;
    username: string;
}

export class ChangePasswordModel {
    username: string;
    oldPassword: string;
    newPassword: string;
}

export class UsageConditionsModel {
    id: number;
    name: string;
    content: string;

}

export class UserConditionsSaveModel {
    id: number;
    supplierUserId: number;
    conditionsId: number;
}


export class ResetLinkModel {
    userName: string;
    redirectAddress: string;
}


export class UserModel {
    id?: number;
    firstName: string;
    lastName: string;
    roleId: number;
    roleName: string;
    rolesNameAndId: Array<RolesInUserModel> = [];
}

class RolesInUserModel {
    id?: number;
    name: string;

}
